var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApi = function SvgApi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#api_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 5.29V8a1 1 0 1 0 2 0V5.29a2.5 2.5 0 1 0-2 0M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4m6-2v2.711a2.5 2.5 0 1 1-2 0V8a1 1 0 0 1 2 0M8 4h2.711a2.5 2.5 0 1 0 0-2H8a1 1 0 0 0 0 2m-2.71 8H8a1 1 0 0 1 0 2H5.29a2.5 2.5 0 1 1 0-2",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "api_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgApi;